import Fetch from '../../../mixins/Fetch'

const loadSolicitationByIdUser = ({ commit }) => {
  const request = Fetch.get('historic/getbyiduser')

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const list = []
  result.then((data) =>
    data.map((s) =>
      list.push({
        tipoEmpreendimento: s.tipoEmpreendimento,
        servico: s.idServico,
        tipoServico: s.tipoServico,
        motivo: s.idMotivo,
        nomeEmpreendimento: s.nomeEmpreendimento,
        nomeEmpresa: s.nomeEmpresa,
        nomeCidade: s.nomeCidade,
        protocolo: s.protocolo,
        unidade: s.unidade,
        status: s.status,
        cidade: s.cidade,
        nomeUn: s.nomeUn,
        bairro: s.bairro,
        rua: s.rua
      })
    )
  )
  commit('SETSOLICITATIONS', list)
  commit('SETSOLICITATIONSPRIMEIROCARREGAMENTO', list)
}

const loadFilesByHistoric = ({ commit }, params) => {
  const request = Fetch.get('archive/getbyhistoric', params)

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const list = []

  result.then((ar) =>
    ar.map((data) =>
      list.push({ id: data.id, nomeOriginal: data.nomeOriginal })
    )
  )
  commit('SETARCHIVES', list)
}

const overlap = ({ commit }, info) => {
  commit('SETOVERLAP', info)
}

const filterSols = ({ commit, getters }, payload) => {
  const cidade = payload.cidades.map((c) => c.value)
  const unidade = payload.unidades.map((u) => u.value)
  const nomeEmpreendimento = payload.empreendimentos.map((e) => e.text)
  const status = payload.status.map((c) => c.text)
  const servico = payload.servico.map((c) => c.value)
  const motivo = payload.motivo.map((c) => c.value)

  if ((payload.protocolo === '' ||
      payload.protocolo === null ||
      typeof payload.protocolo === 'undefined') &&
    cidade.length === 0 &&
    unidade.length === 0 &&
    nomeEmpreendimento.length === 0 &&
    status.length === 0 &&
    servico.length === 0 &&
    motivo.length === 0
  ) {
    loadSolicitationByIdUser({ commit })
  } else if (
    payload.protocolo !== '' &&
    payload.protocolo !== null &&
    typeof payload.protocolo !== 'undefined'
  ) {
    const request = Fetch.get('historic/getbyprotocol', payload.protocolo)

    if (request.status === 'error') throw new Error(request.message)

    const result = request

    commit('SETSOLICITATIONS', result)
  } else if (nomeEmpreendimento.length > 0) {
    commit('SETSOLICITATIONS', getters.getSolicitationsPrimeiroCarregamento)
    const list = getters.getSolicitations.filter((ss) => {
      return nomeEmpreendimento.includes(ss.nomeEmpreendimento)
    })

    commit('SETSOLICITATIONS', list)
  } else {
    commit('SETSOLICITATIONS', getters.getSolicitationsPrimeiroCarregamento)
    const filters = {
      cidade,
      unidade,
      servico,
      motivo
    }

    let list = getters.getSolicitations.filter((item) => {
      for (const key in filters) {
        if (filters[key].length > 0) {
          if (!filters[key].includes(item[key])) {
            return false
          }
        }
      }
      return true
    })

    if (status.length > 0 && status.length < 2) {
      if (status.includes('Backoffice')) {
        list = list.filter((el) => status.includes(el.status))
      } else {
        list = list.filter((el) => el.status !== 'Backoffice')
      }
    }

    commit('SETSOLICITATIONS', list)
  }
}

const loadReasonsSabesp = async ({ commit }) => {
  const request = await Fetch.get('reason/get', 1)

  if (request.status === 'error') throw new Error(request.message)

  const response = request
  const list = []

  response.map((re) => list.push({ value: re.id, text: re.descricao }))

  commit('SETREASONSSABESP', list)
}

const loadGroupedSolicitations = async ({ commit }) => {
  const request = await Fetch.get('historic/getGroupedSolicitation')

  if (request.status === 'error') throw new Error(request.message)

  const result = Array.isArray(request) ? request : []

  commit('SETGROUPEDSOLICITATIONS', result)
}

const loadSolicitationsGroupedStatus = async ({ commit }, status) => {
  const request = await Fetch.get(
    'historic/getGroupSolicitationByStatus',
    status
  )

  if (request.status === 'error') throw new Error(request.message)

  const result = Array.isArray(request) ? request : []

  commit('SETGROUPEDSOLICITATIONSSTATUS', result)

  return request
}

const setModalAddMsgSolicitationInfo = ({ commit }, info) => {
  commit('SETMODALADDMSGSOLICITATIONINFO', info)
}

const addHistoric = async ({ commit }, data) => {
  const request = await Fetch.post('historic/add', data)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const addAttachmentFromTimeLine = async ({ commit }, data) => {
  const errors = []
  const formData = data.formData
  // const { forEach } = data.files

  // forEach(async (el) => {
  //   const infoFile = new FormData()
  //
  //   await [...formData].forEach((el) => {
  //     infoFile.append(el[0], el[1])
  //   })
  //
  //   infoFile.append('anexo', el)
  //
  //   const request = await Fetch.post(
  //     'archive/addattachmentfromtimeline',
  //     infoFile
  //   )

  for (const el of data.files) {
    const infoFile = new FormData()

    await [...formData].forEach((el) => {
      infoFile.append(el[0], el[1])
    })

    infoFile.append('anexo', el)

    const request = await Fetch.post(
      'archive/addattachmentfromtimeline',
      infoFile
    )

    if (request.status === 'error') errors.push(request.message)
  }

  return { error: errors }
}

const downloadLgpd = async () => {
  const request = await Fetch.get('archive/lgpd', null, 'blob')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const actionCheckExpSurveyUX = async ({ commit }, opts) => {
  const request = await Fetch.get(`solicitation/checkexpsurveyux/${opts.protocol}`)

  if (request.status === 'error') throw new Error(request.message)
  commit('SETACTIVEPROTOCOL', opts)

  return request
}

const loadSolicitationByProtocol = async ({ commit }, protocol) => {
  const request = await Fetch.get(`solicitation/getsinglesolicitationbyprotocol/${protocol}`)

  if (request?.status === 'error') throw new Error(request.message)

  commit('SETSOLICITATIONTOVIEW', request)
}

const changeHistoricoDataToAlter = ({ commit }, data) => {
  commit('SETMODALALTERHISTORICODATA', data)
}

const checkAlterCancelPermission = async ({ commit }, data) => {
  const request = await Fetch.get('timeline/checkPermissionAlterCancel')

  if (request?.status === 'error') throw new Error(request.message)

  commit('SETALTERCANCELPERMISSION', request)
}

const alterEditComment = async ({ commit }, data) => {
  const request = await Fetch.post('timeline/alterCancelComment', data)

  if (request?.status === 'error') throw new Error(request.message)

  return request
}

const loadAlterCancelChanges = async ({ commit }, data) => {
  const request = await Fetch.get(`historic/getAltCancelChanges/${data}`)

  if (request?.status === 'error') throw new Error(request.message)

  commit('SETALTERCANCELCHANGES', request)
}

export default {
  loadSolicitationByIdUser,
  loadFilesByHistoric,
  filterSols,
  loadReasonsSabesp,
  downloadLgpd,
  loadGroupedSolicitations,
  loadSolicitationsGroupedStatus,
  setModalAddMsgSolicitationInfo,
  addHistoric,
  addAttachmentFromTimeLine,
  overlap,
  actionCheckExpSurveyUX,
  loadSolicitationByProtocol,
  changeHistoricoDataToAlter,
  checkAlterCancelPermission,
  alterEditComment,
  loadAlterCancelChanges
}
